import { QueryKey, useQueryClient } from "@tanstack/react-query";
import { RowType } from "PFApp/booking/types/row";

import { rowChildrenKeys } from "./query_keys";
import { RowsChildrenResult } from "./use_rows_children";

export const useRowsChildrenInvalidate = () => {
  const queryClient = useQueryClient();

  return {
    invalidateAll: () => queryClient.invalidateQueries({ queryKey: rowChildrenKeys.all() }),
    removeAllCache: () => queryClient.removeQueries({ queryKey: rowChildrenKeys.all() }),
    invalidateByActivityIds: (activityIds: number[]) => {
      const cacheEntries: [QueryKey, RowsChildrenResult?][] = queryClient
        .getQueriesData<RowsChildrenResult>({ predicate: rowChildrenKeys.isRowChildrenQuery })
        .filter(
          //eslint-disable-next-line @typescript-eslint/no-unused-vars
          ([[all, calendarRoot, rowKey], rowChildrenData]) =>
            activityIds
              .flatMap((id) => [`${RowType.Engagement}_${id}`, `${RowType.Role}_${id}`])
              .some((potentialKey) => (rowKey as string).includes(potentialKey)) ||
            !!rowChildrenData?.response?.entries.find(
              (entry) => "activity" in entry && activityIds.includes(entry.activity?.id)
            )
        );
      if (!cacheEntries || !cacheEntries.length) {
        return;
      }
      return Promise.all(cacheEntries.map(([queryKey]) => queryClient.invalidateQueries({ queryKey })));
    },
    invalidateByProfileIds: (profileIds: number[]) => {
      const cacheEntries: [QueryKey, RowsChildrenResult?][] = queryClient
        .getQueriesData<RowsChildrenResult>({ predicate: rowChildrenKeys.isRowChildrenQuery })
        .filter(
          //eslint-disable-next-line @typescript-eslint/no-unused-vars
          ([[all, calendarRoot, rowKey], rowChildrenData]) =>
            profileIds
              .map((id) => `${RowType.Profile}_${id}`)
              .some((potentialKey) => (rowKey as string).includes(potentialKey)) ||
            !!rowChildrenData?.response?.entries.find(
              (entry) => "profile" in entry && profileIds.includes(entry.profile?.id)
            )
        );
      if (!cacheEntries || !cacheEntries.length) {
        return;
      }
      return Promise.all(cacheEntries.map(([queryKey]) => queryClient.invalidateQueries({ queryKey })));
    }
  };
};
